import { render, staticRenderFns } from "./ObservationStatistics.vue?vue&type=template&id=d4d72242&scoped=true&"
import script from "./ObservationStatistics.vue?vue&type=script&lang=js&"
export * from "./ObservationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ObservationStatistics.vue?vue&type=style&index=0&id=d4d72242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d72242",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VContainer,VDivider})
